import { useState, useEffect, FC, FormEvent } from 'react';

import logoPNG from '../img/logo-big-blackBG.png';

import NFTCard from '../components/NFTCard';
import { cardsLib } from '../services/cardsLib';

import { displayWait } from '../services/helpers';

interface FormDataType {
  [key: string]: FormDataEntryValue;
}

const TestApplication: FC = () => {
  const [cards, setCards] = useState<typeof cardsLib>([]);
  const [waitingSubmit, setWaitingSubmit] = useState<boolean>(false);
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);

  useEffect(() => {
    setCards([cardsLib[12]]);
  }, []);

  async function inputChangeHandler(event: FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault();

    setWaitingSubmit(true);

    const responseBody: FormDataType = {};
    const formData = new FormData(event.currentTarget);
    formData.forEach((value, property: string) => {
      responseBody[property] = value;
    });

    console.log(JSON.stringify(responseBody));

    try {
      const res = await fetch('/api/submit-test-app', {
        method: 'POST',
        body: JSON.stringify(responseBody),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await res.json();
      console.log(data.message);
    } catch (e) {
      console.error('Error submitting form:', e);
    }

    setWaitingSubmit(false);
    setFormSubmitted(true);
  }

  return (
    <div>
      <section className="pt-7 pb-5 landing-bg text-white overflow-hidden">
        <div className="container py-4">
          <div className="row">
            <div className="col-xl-11 mx-auto">
              <div className="row">
                <div className="col-md-12 col-xl-8 text-center mx-auto">
                  <div className="d-block my-4">
                    <img src={logoPNG} className="home-logo" alt="" />
                    <h1 className="display-4 fw-bold mb-3 text-white">Incentivised Test Application</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {formSubmitted && (
        <div className="container test-application-container">
          <div className="row home-stats-row">
            <div className="col">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col mt-0">
                      <h5 className="card-title">Application Submitted</h5>
                    </div>
                  </div>
                  <div className="mb-3 error-placeholder">
                    <small className="form-text d-block text-muted">
                      Application successfully submitted. We will notify you via email if you get selected for the
                      test. Stay tuned!
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {!formSubmitted && (
        <form onSubmit={inputChangeHandler}>
          <div className="container test-application-container">
            <div className="row home-stats-row">
              <div className="col">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col mt-0">
                        <h5 className="card-title">Email *</h5>
                      </div>
                    </div>
                    <div className="mb-3 error-placeholder">
                      <input
                        type="text"
                        className="form-control"
                        name="email"
                        placeholder="Email"
                        maxLength={255}
                        required
                      />
                      <small className="form-text d-block text-muted">
                        We will use this email to notify you about your application.
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />
            <br />

            <div className="row home-stats-row">
              <div className="col">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col mt-0">
                        <h5 className="card-title">Discord Name *</h5>
                      </div>
                    </div>
                    <div className="mb-3 error-placeholder">
                      <input
                        type="text"
                        className="form-control"
                        name="discord"
                        placeholder="Discord Name"
                        maxLength={255}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />
            <br />

            <div className="row home-stats-row">
              <div className="col">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col mt-0">
                        <h5 className="card-title">Solana Wallet *</h5>
                      </div>
                    </div>
                    <div className="mb-3 error-placeholder">
                      <input
                        type="text"
                        className="form-control"
                        name="wallet"
                        placeholder="Solana Wallet Address"
                        maxLength={255}
                        required
                      />
                      <small className="form-text d-block text-muted">
                        Phantom or other Solana wallet is required to test the game. Test tokens and your reward will
                        be given to this wallet.
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />
            <br />

            <div className="row home-stats-row">
              <div className="col">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col mt-0">
                        <h5 className="card-title">Basics</h5>
                      </div>
                    </div>
                    <div className="mb-3 error-placeholder">
                      <small className="form-text d-block text-muted">
                        The test will be composed of a number of simple tasks that you will need to complete in order
                        to be eligible for a reward. Failure to complete all tasks will result in no reward. If you
                        notice any bugs in the game, please notify us as soon as possible. That's the whole purpose of
                        the test!
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />
            <br />

            <div className="row home-stats-row">
              <div className="col">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col mt-0">
                        <h5 className="card-title">Reward</h5>
                      </div>
                    </div>
                    <div className="mb-3 error-placeholder">
                      <div className="row">
                        {cards.map((card, index) => (
                          <div className="nft-card" key={index}>
                            <div className="card">
                              <NFTCard card={card} />
                              <div className="card-header">
                                <h5 className="card-title mb-0">{card.name}</h5>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      <small className="form-text d-block text-muted">This Tier 4 Bear is worth 360$</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />
            <br />

            <div className="row home-stats-row">
              <div className="col">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col mt-0">
                        <h5 className="card-title">Terms</h5>
                      </div>
                    </div>
                    <div className="mb-3 error-placeholder">
                      <small className="form-text d-block text-muted">
                        The game is of type invest-to-earn, and is intended for{' '}
                        <span className="red-terms">adults only</span>. You must of age{' '}
                        <span className="red-terms">18+</span> to participate in the game and the Game Test.
                      </small>

                      <br />

                      <small className="form-text d-block text-muted">
                        Multi-accounts are <span className="red-terms">strictly forbidden</span>. One person can
                        participate in the Game Test just once. If anyone caught with multiple accounts, no reward will
                        be given to such person.
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section className="py-5">
            <div className="container text-center">
              <div className="row">
                <div className="col-lg-6 mx-auto">
                  {waitingSubmit && displayWait}
                  {!waitingSubmit && (
                    <button type="submit" className="btn btn-secondary load-more-button">
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </div>
          </section>
        </form>
      )}
    </div>
  );
};

export default TestApplication;
